import Const from 'const';

interface Messages {
    readonly stackingEnableMessage: string;
    readonly stackingDisableMessage: string;
    readonly competitionOpponentsTitle: string;
    readonly competitionSelectPlaceholder: string;
    readonly uniqueCompetitionErrorMessage: string;
    readonly competitionsNotBlankMessage: string;
}

const messagesMap: {[key: string]: Messages} = {
    [Const.COMPETITION_STACKING_TYPE_FIGHT]: {
        stackingEnableMessage: 'Enable fight stacks',
        stackingDisableMessage: 'Disable fight stacks',
        competitionOpponentsTitle: 'Stack Fighter vs Opponent',
        competitionSelectPlaceholder: 'Select fights',
        uniqueCompetitionErrorMessage: 'Fights have to be unique.',
        competitionsNotBlankMessage: 'Fights cannot be blank.',
    },
    [Const.COMPETITION_STACKING_TYPE_MATCH]: {
        stackingEnableMessage: 'Enable match stacks',
        stackingDisableMessage: 'Disable match stacks',
        competitionOpponentsTitle: 'Stack Player vs Opponent',
        competitionSelectPlaceholder: 'Select matches',
        uniqueCompetitionErrorMessage: 'Matches have to be unique.',
        competitionsNotBlankMessage: 'Matches cannot be blank.',
    },
};

export default class {
    public static getCompetitionStackingEnableMessage(competitionType: string): string {
        return this.getMessage(competitionType, 'stackingEnableMessage');
    }

    public static getCompetitionStackingDisableMessage(competitionType: string): string {
        return this.getMessage(competitionType, 'stackingDisableMessage');
    }

    public static getCompetitionOpponentsTitle(competitionType: string): string {
        return this.getMessage(competitionType, 'competitionOpponentsTitle');
    }

    public static getCompetitionSelectPlaceholder(competitionType) {
        return this.getMessage(competitionType, 'competitionSelectPlaceholder');
    }

    public static getUniqueCompetitionErrorMessage(competitionType) {
        return this.getMessage(competitionType, 'uniqueCompetitionErrorMessage');
    }

    public static getCompetitionsNotBlankMessage(competitionType) {
        return this.getMessage(competitionType, 'competitionsNotBlankMessage');
    }

    private static getMessage(competitionType: string, messageName: string): string {
        return competitionType in messagesMap ? messagesMap[competitionType][messageName] : '';
    }
}
